<template>
    <div class="wrapper">
        <TitleModules title="产品案例" english="INTRODUCE" type="blue"></TitleModules>
        <div class="img-text-content-box">
            <div class="text-content-box" style="margin-right: 70px;">
                <img class="number-bg" data-src="../../static/img/bg-img1.png" alt="">
                <div class="text-content-title">线下网球馆：勾勾运动</div>
                <div class="text-content-subtitle">OFFLINE TENNIS STADIUM: HOOK SPORT</div>
                <div class="text-content">基于用户使用便捷性和场馆管理智能化考虑，为上海卢湾网球中心赋能，定制开发了一套集场地预定管理、会员申请审核、课程预定、优惠礼券、多种订单及财务退款等一体化在线智能管理系统，并提供双语版智能切换和多种用户角色切换功能，轻松实现管理智能化和高效性，打造成集运动、消费、社交等功能于一体的专注于网球运动垂直领域O2O的运动生活平台。</div>
            </div>
            <div class="img-content-box">
                <img class="content-img1" data-src="../../static/img/content-img1.png" alt="">
            </div>
        </div>
        <div class="img-text-content-box" style="background: #F6F7FC">
            <div class="img-content-box" style="margin-right: 160px;">
                <img class="content-img2" data-src="../../static/img/content-img2.png" alt="">
            </div>
            <div class="text-content-box">
                <img class="number-bg" data-src="../../static/img/bg-img2.png" alt="">
                <div class="text-content-title">线下画廊:艺直购</div>
                <div class="text-content-subtitle">OFFLINE GALLERY: ART DIRECT OURCHASE</div>
                <div class="text-content">将线下画廊从传统生意转变为STOBTOC的业务模式（消费艺术品垂直类的淘宝），实现艺术家和机构的入驻审核和作品发布，为艺术家、画廊机构和用户搭建起艺术作品交易新平台，开启线上销售渠道。并借助技术实力驱动产品创新，实现装裱效果和场装饰场景实时预览，给用户提供更直观的购买体验。</div>
            </div>
        </div>
        <div class="img-text-content-box">
            <div class="text-content-box" style="margin-right: 70px;">
                <img class="number-bg" data-src="../../static/img/bg-img3.png" alt="">
                <div class="text-content-title">线下体育赛事：WCT追逐大赛</div>
                <div class="text-content-subtitle">OFFLINE SPORTS EVENTS: WORLD CHASE COMPETITION</div>
                <div class="text-content">WCT追逐大赛小程序端结合后台管理系统，为官方发布赛事信息、统计用户报名信息、比赛成绩和更新排名实现数字化和信息化，为用户提供从赛前、赛中到赛后提供一站式服务。</div>
            </div>
            <div class="img-content-box">
                <img class="content-img3" data-src="../../static/img/content-img3.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import TitleModules from '../components/Title-modules'
export default {
    name: 'linkLine',
    components: {
        TitleModules
    },
    data(){
        return {

        }
    },
    created(){
        localStorage.setItem('path','./linkLine')
        localStorage.setItem('index',3)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1480px){
    .content-img1{
        height: 485px;
    }
    .content-img2{
        height: 558px;
    }
    .content-img3{
        height: 482px;
    }
    .img-text-content-box{
        width: 100%;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items:center;
    }
    .text-content-box{
        width: 580px;
        position: relative;
    }
    .text-content-title{
        font-size: 37px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 51px;
    }
    .text-content-subtitle{
        font-size: 25px;
    }
    .text-content{
        width: 553px;
        font-size: 21px;
        line-height: 40px;
        margin-top: 40px;
    }
    .text-content > span{
        font-size: 24px;
        font-weight: bold;
        color: #4468E6;
    }
    .number-bg{
        position: absolute;
        height: 285px;
        left: 40px;
        top: -65px;
    }
}
@media only screen and (min-width: 1480px){
    .content-img1{
        height: 680px;
    }
    .content-img2{
        height: 780px;
    }
    .content-img3{
        height: 680px;
    }
    .img-text-content-box{
        width: 100%;
        height: 830px;
        display: flex;
        justify-content: center;
        align-items:center;
    }
    .text-content-box{
        width: 810px;
        position: relative;
    }
    .text-content-title{
        font-size: 52px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 72px;
    }
    .text-content-subtitle{
        font-size: 34px;
    }
    .text-content{
        width: 778px;
        font-size: 30px;
        line-height: 56px;
        margin-top: 50px;
    }
    .text-content > span{
        font-size: 34px;
        font-weight: bold;
        color: #4468E6;
    }
    .number-bg{
        position: absolute;
        height: 285px;
        left: 40px;
        top: -65px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/linkLine.vue